export const sortBy = (key, order = "asc") => (a, b) => {
  const compareA = a[key].toLowerCase();
  const compareB = b[key].toLowerCase();

  const sort = {
    asc: compareA < compareB ? -1 : compareA > compareB ? 1 : 0,
    desc: compareA < compareB ? 1 : compareA > compareB ? -1 : 0
  };

  return sort[order];
};
